import React from 'react';
import { Modal } from 'react-bootstrap';
import Spinner from '../../subcomponent/spinner';

const LoadingModal = ({ show, onHide }) => {
  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      backdrop="static"
    >
      <Modal.Header closeButton style={{ borderBottom: '2px solid #667eea' }}>
        <Modal.Title style={{ color: '#667eea', fontWeight: '600' }}>
          ⏳ Generando PDF
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ padding: '2rem', textAlign: 'center' }}>
        <div className="mb-3">
          <Spinner loading={true} />
        </div>
        <p style={{ marginBottom: '0.5rem', fontWeight: '600' }}>
          El PDF se está generando
        </p>
        <p style={{ color: '#6c757d', marginBottom: 0 }}>
          Por favor no recargue la página. El archivo se descargará automáticamente cuando esté listo.
        </p>
      </Modal.Body>
    </Modal>
  );
};

export default LoadingModal;


// WEBPACK FOOTER //
// ./src/components/nomina/components/LoadingModal.jsx